<template>
    <div class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 pr-under-md-0 pl-under-md-0">
      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form class="d-flex w-100">
          <b-input-group
            class="mb-2 w-100 annonce-create-search-bar"
            size="sm">
            <b-input-group-append>
              <b-input-group-text class="search-input-append">
                <i class="ph-custom ph-magnifying-glass"/>
              </b-input-group-text>
            </b-input-group-append>
            <b-form-input
              class="search-input"
              :class="{'active': searchInput}"
              v-model="searchInput"
              type="search"
              maxlength="250"
              :placeholder="$t('Research')">
            </b-form-input>
          </b-input-group>
        </b-form>
      </div>
      <div v-if="selectedVehicleType.invalidFeedback" class="d-block col-12 pl-0 pr-0 invalid-feedback mb-2">{{selectedVehicleType.invalidFeedback}}</div>
      <div id="annonce-create-items-list" class="item-container-annonce styled-scrollbar-custom" v-show="filteredVehicleTypes.length !== 0  && !isLoadingVehicles">
        <div id="annonce-create-items-list-around">
          <transition-group name="listCustomTransition" tag="div" id="annonce-create-items-list-inside" class="item-container-annonce">
            <div v-show="filteredVehicleTypes.length > 0" class="item-annonce cursor-pointer" :class="{'item-active': selectedVehicleType.value === vehicleType.id, 'item-invalid': selectedVehicleType.invalidFeedback}" v-for="vehicleType in filteredVehicleTypes" :key="vehicleType.id" @click="setSelectedVehicleType(vehicleType)">
              <div class="d-flex justify-content-center align-items-center text-center">{{vehicleType.name}}</div>
            </div>
          </transition-group>
        </div>
      </div>
      <div id="annonce-create-items-list-empty" v-show="filteredVehicleTypes.length === 0  && !isLoadingVehicles" class="w-100 styled-scrollbar-custom">
        <div class="empty-state-container">
          <div id="empty-state-container-img-part" class="text-center pb-2">
            <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result" class="empty-state-img">
          </div>
          <div id="empty-state-container-text-part" class=" text-center no-result-text">
            <div class="no-result-title mb-2">{{ $t('annonce.empty.vehicleType.emptyTitle') }}</div>
            <div class="no-result-subtitle my-2">{{ $t('annonce.empty.vehicleType.emptyText') }}</div>
          </div>
        </div>
      </div>
      <div id="annonce-create-items-list-loading" v-show="isLoadingVehicles" class="w-100 styled-scrollbar-custom">
        <div class="w-100 d-flex justify-content-center mt-4">
          <b-spinner class="list-spinner"></b-spinner>
        </div>
      </div>
    </div>
</template>

<script>
import api from "../../../services/api";

export default {
  name: "AnnonceCreateStep1",

  emits:["updateAnnonce"],

  props:{
    annonce : {
      required: true,
      type: Object
    }
  },

  data(){
    return {
      vehicleTypes : [],
      isLoadingVehicles:true,
      selectedVehicleType:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      searchInput:null
    }
  },

  async mounted() {
    this.selectedVehicleType=this.annonce.vehicleType
    await this.fetchVehicleType()
  },

  computed: {
    filteredVehicleTypes() {
      let result = [];
      this.selectedVehicleType.state = null;
      this.selectedVehicleType.invalidFeedback = null;

      if (this.searchInput) {
        result = this.vehicleTypes.filter((type) =>
          type.name.toLowerCase().includes(this.searchInput.toLowerCase())
        );
      } else {
        result = [...this.vehicleTypes];
      }

      return result;
    }
  },

  methods:{

    async fetchVehicleType(){
      api
        .get(`/vehicleType/getAllActivated`)
        .then(response => {
          this.vehicleTypes = response.data
          this.isLoadingVehicles = false
         })
        .catch(error => {
          console.error('Erreur lors de la récupération des véhicules', error)
          this.isLoadingVehicles = false
        });
    },

    setSelectedVehicleType(vehicleType){
      if(this.selectedVehicleType.value!==vehicleType.id){
        this.selectedVehicleType.value=vehicleType.id
        this.selectedVehicleType.invalidFeedback=null
        this.selectedVehicleType.state=null
      }
      else{
        this.selectedVehicleType.value=null
        this.selectedVehicleType.invalidFeedback=null
        this.selectedVehicleType.state=null
      }
      this.annonce.vehicleType = this.selectedVehicleType
      this.annonce.isLicensed = vehicleType.isLicensed
      this.$emit('updateAnnonce', this.annonce)
    }
  },
}
</script>

<style scoped>

/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #annonce-create-items-list, #annonce-create-items-list-empty, #annonce-create-items-list-loading {
    height: calc(100% - 42px);
    overflow: auto;
  }
  #annonce-create-items-list-inside {
    padding-bottom: 40px; /* place pour un peu de marge et si il y a un invalid feedback */
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
  #annonce-create-items-list-empty .empty-state-container {
    min-height: 140px;
    height: unset;
    margin-top: 0px;
    padding-bottom: 20px; /* place pour un peu de marge */
    margin-bottom: auto; /* c'est pas assez grand pour remplir la hauteur */
  }
  #annonce-create-items-list-empty #empty-state-container-img-part {
    height: 140px;
  }
  #annonce-create-items-list-empty .empty-state-img {
    height: 100%;
  }
  #annonce-create-items-list-empty #empty-state-container-text-part {
    min-height: 50%;
  }
}

.item-invalid {
  border-color: var(--main-red-medium) !important;
}

#annonce-create-items-list {
  margin-left: -0.25em;
}
#annonce-create-items-list-around {
  width: 100%;
  padding-right: 0.25em;
  padding-left: 0.25em;
}
#annonce-create-items-list-inside {
  margin-left: -0.25em;
}

.item-annonce {
  margin: 0.25em;

  -ms-flex: 0 0 50%;
  -webkit-box-flex: 0;
  flex: 0 0 50%;
  max-width: calc(50% - 0.5em);
  border-radius: 10px;
  background-color: var(--main-black-medium);
  padding: 2rem;
  border: 1px solid var(--main-black-medium);
  display: flex;
  justify-content: center;
}

.item-annonce:hover {
  background-color: var(--main-black-light);
}

.item-active{
  border-color:var(--main-yellow-medium)!important;
}


.item-container-annonce{
  display: flex;
  flex-wrap: wrap;
  -ms-flex: 0 0 calc(100% + 0.5em);
  -webkit-box-flex: 0;
  width: calc(100% + 0.5em);
  max-width: calc(100% + 0.5em);
  flex: 0 0 calc(100% + 0.5em);
}

/** search bar */
.annonce-create-search-bar .search-input, .annonce-create-search-bar .search-input-append {
  background-color: transparent !important;
  border-color: var(--main-grey-dark) !important;
  color: var(--main-grey-light) !important;
}
.annonce-create-search-bar .search-input {
  position: relative;
  border-radius: var(--fourth-border-radius) !important;
  font-size: var(--content-font-size);
  padding-left: calc(1rem + 20px) !important;
}
.annonce-create-search-bar .search-input-append {
  position: absolute;
  z-index: 2;
  height: 100%;
  border-style: none;
}
.annonce-create-search-bar .search-input.active {
  border-color: var(--main-yellow-medium) !important;
}
.annonce-create-search-bar .search-input.in-error {
  border-color: var(--main-red-medium) !important;
}


.search-input:focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 237, 0, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(255, 237, 0, 0.5);
}

</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateStep1.vue